import { Link } from "react-router-dom";
import { RefreshCw, SearchX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { RoutePath } from "../../routerPaths";

/** Full-page "We couldn't open this …" state with Try again and a way back to the CRM list. */
export function CrmLoadError({
  subject,
  isRetrying,
  onRetry,
}: {
  /** "record" or "record group". */
  subject: string;
  isRetrying: boolean;
  onRetry: () => void;
}) {
  return (
    <div className="flex min-h-full items-center justify-center bg-slate-50 px-6 py-24">
      <div className="max-w-md text-center" data-testid="crm-detail-error">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-500">
          <SearchX className="h-6 w-6" />
        </span>
        <h1 className="mt-4 text-xl font-semibold text-gray-900">We couldn't open this {subject}</h1>
        <p className="mt-2 text-sm text-gray-500">
          It may have been removed, or something went wrong. Try again, or go back to the CRM list.
        </p>
        <div className="mt-6 flex justify-center gap-3">
          <Button variant="outline" disabled={isRetrying} onClick={onRetry}>
            <RefreshCw className={cn("mr-2 h-4 w-4", isRetrying && "animate-spin")} />
            Try again
          </Button>
          <Button asChild>
            <Link to={RoutePath.CrmList}>Back to CRM</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
